import { LoadableAfterPaint } from '@confluence/loadable';

export const ExpandExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExpandExtensionHandler" */ '../src/ExpandExtensionHandler.tsx'
			)
		).ExpandExtensionHandler,
});
